/** Unit conversions. The database stores kg and cm; the UI shows the user's choice. */
import type { UnitSystem } from './types';

export const KG_PER_LB: number = 0.45359237;
export const CM_PER_IN: number = 2.54;

export const kgToLb = (kg: number): number => kg / KG_PER_LB;
export const lbToKg = (lb: number): number => lb * KG_PER_LB;

export function massFromKg(kg: number, units: UnitSystem): number {
  return units === 'imperial' ? kgToLb(kg) : kg;
}

export function massToKg(value: number, units: UnitSystem): number {
  return units === 'imperial' ? lbToKg(value) : value;
}

export const massUnit = (units: UnitSystem): string => (units === 'imperial' ? 'lb' : 'kg');

export function formatMass(kg: number | null | undefined, units: UnitSystem, digits: number = 1): string {
  if (kg === null || kg === undefined || !Number.isFinite(kg)) return '—';
  return `${massFromKg(kg, units).toFixed(digits)} ${massUnit(units)}`;
}

export function cmToFeetInches(cm: number): { feet: number; inches: number } {
  const totalIn: number = cm / CM_PER_IN;
  let feet: number = Math.floor(totalIn / 12);
  let inches: number = Math.round((totalIn - feet * 12) * 10) / 10;
  if (inches >= 12) { feet += 1; inches -= 12; }
  return { feet, inches };
}

export const feetInchesToCm = (feet: number, inches: number): number => (feet * 12 + inches) * CM_PER_IN;

export function formatNumber(n: number | null | undefined, digits: number = 0): string {
  if (n === null || n === undefined || !Number.isFinite(n)) return '—';
  return n.toLocaleString(undefined, { minimumFractionDigits: digits, maximumFractionDigits: digits });
}
